<template>
  <div class="allocation">
    <Header :title="pageTitle">
      <el-button type="primary" class="print-btn" @click="pdfgen">PRINT</el-button>
      <el-button type="primary" class="back-btn" @click="goBack">BACK</el-button>
    </Header>
    <AllocationDetails
      ref="allocationDetails"
      :type="programAllocation.allocationType"
      :allocation="programAllocation">
    </AllocationDetails>
    <div class="section">
      <el-row>
        <el-col :span="16" class="allocation-total-section">
          <AllocationTotalTable :allocation="programAllocation" readonly></AllocationTotalTable>
        </el-col>
        <el-col :span="8">
          <FteTable
            title="Total FTE"
            :allocation="programAllocation"
            readonly
            :show-tooltip="false">
          </FteTable>
        </el-col>
      </el-row>
    </div>
    <div class="section">
      <InputLabel value="Program summary/purpose" margin-bottom="10" font-size="22"></InputLabel>
      <div v-html="programAllocation.programPurpose" class="html-string"></div>
    </div>
    <div class="section">
      <InputLabel value="Rationale for Allocation" margin-bottom="5" font-size="22"></InputLabel>
      <div class="rationale-text">
        GENERAL FUND ALLOCATIONS ARE TENTATIVE. THE AMOUNTS ALLOCATED MAY
        BE REDUCED BY EXECUTIVE RESTRICTIONS AND/OR INTERNAL REDUCTIONS.
      </div>
      <div v-html="programAllocation.allocationRationale" class="html-string"></div>
    </div>
    <div class="section">
      <InputLabel
        value="Guidelines for Implementation"
        margin-bottom="10"
        font-size="22">
      </InputLabel>
      <div v-html="programAllocation.implementationGuidelines" class="html-string"></div>
      <br />
      <div class="html-string"><ul>{{programAllocation.fedPayroll}}</ul></div>
      <br />
      <div class="html-string"><ul>{{programAllocation.costSaving}}</ul></div>
      <el-button
        v-if="programAllocation.isFedPayrollCert"
        class="guidelines-pdf"
        type="text"
        @click="openFedPayrollPDF">
        Read {{programAllocation.fedPayrollName}} pdf <i class="el-icon-document"></i>
      </el-button>
      <el-button
        v-if="programAllocation.isFringeBenefit"
        class="guidelines-pdf"
        type="text"
        @click="openFringeBenefitPDF">
        Read {{programAllocation.fringeBenefitName}} pdf <i class="el-icon-document"></i>
      </el-button>
    </div>
    <div class="section">
      <AllocationOfResourcesTable :table-data="computedTableData"></AllocationOfResourcesTable>
    </div>
    <div class="section allocation-fte">
      <AllocationOfFteTable :table-data="computedTableData"></AllocationOfFteTable>
    </div>
    <div class="section">
      <el-button type="primary" class="back-btn" @click="goBack">BACK</el-button>
    </div>
    <FullScreenLoadingSpinner v-if="fullScreenLoading"></FullScreenLoadingSpinner>
  </div>
</template>

<script>
import Header from '../components/headers/MainContentHeader.vue';
import AllocationDetails from '../components/details/AllocationDetails.vue';
import InputLabel from '../components/misc/InputLabel.vue';
import AllocationTotalTable from '../components/tables/AllocationTotalTable.vue';
import FteTable from '../components/tables/FteTable.vue';
import AllocationOfResourcesTable from '../components/tables/AllocationOfResourcesTable.vue';
import AllocationOfFteTable from '../components/tables/AllocationOfFteTable.vue';
import FullScreenLoadingSpinner from '../components/misc/FullScreenLoadingSpinner.vue';
import notice from '../utils/notice';
import api from '../utils/api';
import * as Paths from '../constants/paths';

export default {
  name: 'Allocation',
  components: {
    Header,
    AllocationDetails,
    InputLabel,
    AllocationTotalTable,
    FteTable,
    AllocationOfResourcesTable,
    AllocationOfFteTable,
    FullScreenLoadingSpinner,
  },
  computed: {
    computedTableData() {
      const data = [];
      let allocationA = 0;
      let allocationA1 = 0;
      let allocationBC = 0;
      let allocationF = 0;
      let allocationT = 0;
      let allocationTotal = 0;
      let fteAppropriatedPerm = 0;
      let fteAppropriatedTemp = 0;
      let fteUnappropriatedTemp = 0;
      this.orgAllocations.forEach((row) => {
        const rowTotal = this.getTotal(row);
        data.push({
          // eslint-disable-next-line no-plusplus
          orgId: row.orgId,
          orgName: row.orgName,
          allocationA: row.allocationA,
          allocationA1: row.allocationA1,
          allocationBC: row.allocationBC,
          allocationF: row.allocationF,
          allocationT: row.allocationT,
          allocationTotal: rowTotal,
          fteAppropriatedPerm: row.fteAppropriatedPerm,
          fteAppropriatedTemp: row.fteAppropriatedTemp,
          fteUnappropriatedTemp: row.fteUnappropriatedTemp,
        });
        allocationA += row.allocationA;
        allocationA1 += row.allocationA1;
        allocationBC += row.allocationBC;
        allocationF += row.allocationF;
        allocationT += row.allocationT;
        allocationTotal += rowTotal;
        fteAppropriatedPerm += row.fteAppropriatedPerm;
        fteAppropriatedTemp += row.fteAppropriatedTemp;
        fteUnappropriatedTemp += row.fteUnappropriatedTemp;
      });
      data.push({
        // eslint-disable-next-line no-plusplus
        orgId: 'Total Allocation',
        orgName: null,
        allocationA,
        allocationA1,
        allocationBC,
        allocationF,
        allocationT,
        allocationTotal,
        fteAppropriatedPerm,
        fteAppropriatedTemp,
        fteUnappropriatedTemp,
      });
      return data;
    },
  },
  data() {
    return {
      pageTitle: 'Allocation',
      allocationId: '',
      programAllocation: {},
      orgAllocations: [],
      fullScreenLoading: false,
    };
  },
  methods: {
    getTotal(funds) {
      return funds.allocationA
        + funds.allocationA1
        + funds.allocationBC
        + funds.allocationF
        + funds.allocationT;
    },
    goBack() {
      // this.$router.push('/dashboard');
      this.$router.go(-1);
    },
    getAndSetProgram(programId, bfy) {
      this.$refs.allocationDetails.getAndSetProgram(programId, bfy);
    },
    getAllocation() {
      this.fullScreenLoading = true;
      api.get(Paths.PROGRAM_ALLOCATION_URL(this.allocationId))
        .then((response) => {
          this.programAllocation = response.data.data;
          this.orgAllocations = response.data.data.orgAllocations;
          this.getAndSetProgram(this.programAllocation.programId, this.programAllocation.bfy);
        })
        .catch(() => {
          // this.$router.push('/dashboard');
          this.$router.go(-1);
        })
        .finally(() => {
          this.fullScreenLoading = false;
        });
    },
    openFedPayrollPDF() {
      if (this.programAllocation.fedPayrollPdfLink) {
        window.open(`${process.env.VUE_APP_DOCS_BASE_URL}/${this.programAllocation.fedPayrollPdfLink}`, '_blank');
      } else {
        notice.fireError('File could not be found.');
      }
    },
    openFringeBenefitPDF() {
      if (this.programAllocation.fringeBenefitPdfLink) {
        window.open(`${process.env.VUE_APP_DOCS_BASE_URL}/${this.programAllocation.fringeBenefitPdfLink}`, '_blank');
      } else {
        notice.fireError('File could not be found.');
      }
    },
    pdfgen() {
      //  const purpose = programAllocation.programPurpose;
      // eslint-disable-next-line global-require,import/no-dynamic-require
      const pdfMake = require('pdfmake/build/pdfmake');
      // eslint-disable-next-line global-require,import/no-dynamic-require
      const htmlToPdfmake = require('html-to-pdfmake');
      // eslint-disable-next-line global-require,import/no-dynamic-require
      // const moment = require('moment');
      if (pdfMake.vfs === undefined) {
      // eslint-disable-next-line global-require,import/no-dynamic-require
        const pdfFonts = require('pdfmake/build/vfs_fonts');
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      // eslint-disable-next-line no-unused-vars
      this.purposeHtml = htmlToPdfmake(this.programAllocation.programPurpose == null ? '' : this.programAllocation.programPurpose.replace('<ul style=3D"padding-left: 18pt">', '')
        .replace('<ul style="padding-left: 18pt">', '').replace('<ul style=3D"padding-left: 36pt">', '').replace('</ul>', ''));
      // eslint-disable-next-line no-unused-vars
      this.rationaleHtml = htmlToPdfmake(`${this.programAllocation.allocationRationale == null ? '' : this.programAllocation.allocationRationale.replace('<ul style=3D"padding-left: 18pt">', '')
        .replace('<ul style="padding-left: 18pt">', '').replace('<ul style=3D"padding-left: 36pt">', '').replace('</ul>', '')}`);
      // eslint-disable-next-line no-unused-vars
      this.guidelinesHtml = htmlToPdfmake(this.programAllocation.implementationGuidelines == null ? '' : this.programAllocation.implementationGuidelines.replace('<ul style=3D"padding-left: 18pt">', '')
        .replace('<ul style="padding-left: 18pt">', '').replace('<ul style=3D"padding-left: 36pt">', '').replace('</ul>', ''));
      const docDefinition = {
        content: [
          { text: 'Allocation', style: 'header' },
          { text: `Program ID: ${this.programAllocation.programId} -  ${this.programAllocation.programName}`, style: '' },
          { text: `Budget Fiscal Year : ${this.programAllocation.bfy}`, style: '' },
          { text: `Lapse Date: ${this.$options.filters.moment(this.$refs.allocationDetails.program.lapseDate, 'MM/DD/YYYY')}`, style: '' },
          { text: `Carry Over: ${this.$refs.allocationDetails.program.carryover}`, style: '' },
          { text: `MOF: ${this.programAllocation.meansOfFinance}`, style: '' },
          { text: `B&F Suborg: ${this.programAllocation.bfSubOrg}`, style: '' },
          { text: `Allocation Number:  ${this.programAllocation.bfy} - ${this.programAllocation.allocationNumber}`, style: '' },
          { text: `Appropriation Code: ${this.programAllocation.appropriationCode}`, style: '' },
          { text: `Allocation Date: ${this.$options.filters.moment(this.programAllocation.approvedDate, 'MM/DD/YYYY')}`, style: '' },
          { text: `Allocation Type: ${this.programAllocation.allocationSubtype}`, style: '' },
          { text: `Program Manager: ${this.programAllocation.programManagerName}`, style: '' },
          { text: `Managing Office: ${this.programAllocation.managingOfficeName}`, style: '' },
          { text: `Adjust OA: ${this.programAllocation.isAdjustOA === true ? 'Yes' : 'No'}`, style: '' },
          { text: '\n Total Allocation', style: 'header' },
          this.maketableTotalAlloc(),
          '\n',
          { text: 'Total FTE', style: 'header' },
          {
            style: 'tableHeader',
            table: {
              headerRows: 1,
              body: [
                [{ text: '', alignment: 'center' }, { text: 'Appropriated', alignment: 'center' }, { text: 'Unappropriated', alignment: 'center' }],
                ['Perm', { text: this.programAllocation.fteAppropriatedPerm.toFixed(2), alignment: 'right' }, ''],
                ['Temp', { text: this.programAllocation.fteAppropriatedTemp.toFixed(2), alignment: 'right' }, { text: this.programAllocation.fteUnappropriatedTemp.toFixed(2), alignment: 'right' }],
                ['Total', { text: this.programAllocation.fteAppropriatedTotal.toFixed(2), alignment: 'right' }, { text: this.programAllocation.fteUnappropriatedTotal.toFixed(2), alignment: 'right' }],
              ],
            },
          },
          '\n',
          { text: 'Program Summary/Purpose', style: 'header' },
          this.purposeHtml,
          '\n',
          { text: 'Rationale for Allocation', style: 'header' },
          { text: 'GENERAL FUND ALLOCATIONS ARE TENTATIVE. THE AMOUNTS ALLOCATED MAY BE REDUCED BY EXECUTIVE RESTRICTIONS AND/OR INTERNAL REDUCTIONS.', style: '' },
          '\n',
          this.rationaleHtml,
          '\n',
          { text: 'Guidelines for Implementation', style: 'header' },
          this.guidelinesHtml,
          this.programAllocation.fedPayroll,
          '\n',
          { text: this.programAllocation.costSaving },
          '\n',
          { text: this.checkFed(), link: this.checkFedLink(), color: 'blue' },
          '\n',
          { text: this.checkFringe(), link: this.checkFringeLink(), color: 'blue' },
          '\n',
          { text: 'Allocation of Resources', style: 'header' },
          this.maketableAllocRes(this.computedTableData),
          { text: '\n Allocation of Fte', style: 'header' },
          this.maketableAllocFTE(this.computedTableData),
        ],
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10],
          },
          subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 10, 0, 5],
          },
          tableExample: {
            margin: [0, 5, 0, 15],
          },
          tableHeader: {
            bold: true,
            fontSize: 10,
            color: 'black',
          },
        },
      };
      pdfMake.createPdf(docDefinition).download('Allocation Completed.pdf');
    },
    maketable(data, columns) {
      return {
        style: 'tableHeader',
        table: {
          headerRows: 1,
          body: this.buildTableBody(data, columns),
        },
      };
    },
    buildTableBody(data, columns) {
      const body = [];
      body.push(columns);
      // eslint-disable-next-line prefer-arrow-callback,import/no-dynamic-require
      data.forEach((row) => {
        const dataRow = [];
        // eslint-disable-next-line prefer-arrow-callback,import/no-dynamic-require
        columns.forEach((column) => {
          dataRow.push(row[column]);
        });
        body.push(dataRow);
      });
      return body;
    },
    maketableAllocRes(data) {
      return {
        style: 'tableHeader',
        table: {
          headerRows: 1,
          body: this.buildTableBodyAllocRes(data),
        },
      };
    },
    buildTableBodyAllocRes(data) {
      const body = [];
      body.push([{ text: 'ORG ID', alignment: 'center' }, { text: 'A', alignment: 'center' }, { text: 'A1', alignment: 'center' },
        { text: 'BC', alignment: 'center' }, { text: 'F', alignment: 'center' }, { text: 'T', alignment: 'center' }, { text: 'Total', alignment: 'center' }]);
      // eslint-disable-next-line prefer-arrow-callback,import/no-dynamic-require
      data.forEach((row) => {
        const dataRow = [];
        if (row.orgId === 'Total Allocation') {
          dataRow.push(row.orgId);
        } else {
          dataRow.push(`${row.orgId} - ${row.orgName}`);
        }
        dataRow.push({ text: this.formatMoney(row.allocationA), alignment: 'right' });
        dataRow.push({ text: this.formatMoney(row.allocationA1), alignment: 'right' });
        dataRow.push({ text: this.formatMoney(row.allocationBC), alignment: 'right' });
        dataRow.push({ text: this.formatMoney(row.allocationF), alignment: 'right' });
        dataRow.push({ text: this.formatMoney(row.allocationT), alignment: 'right' });
        dataRow.push({ text: this.formatMoney(row.allocationTotal), alignment: 'right' });
        body.push(dataRow);
      });
      return body;
    },
    maketableTotalAlloc() {
      return {
        style: 'tableHeader',
        table: {
          headerRows: 1,
          body: this.buildTableBodyTotalAlloc(),
        },
      };
    },
    buildTableBodyTotalAlloc() {
      const body = [];
      body.push([{ text: 'A', alignment: 'center' }, { text: 'A1', alignment: 'center' }, { text: 'BC', alignment: 'center' },
        { text: 'F', alignment: 'center' }, { text: 'T', alignment: 'center' }, { text: 'Total', alignment: 'center' }]);
      const dataRow = [];
      dataRow.push({ text: this.formatMoney(this.programAllocation.allocationTotalA), alignment: 'right' });
      dataRow.push({ text: this.formatMoney(this.programAllocation.allocationTotalA1), alignment: 'right' });
      dataRow.push({ text: this.formatMoney(this.programAllocation.allocationTotalBC), alignment: 'right' });
      dataRow.push({ text: this.formatMoney(this.programAllocation.allocationTotalF), alignment: 'right' });
      dataRow.push({ text: this.formatMoney(this.programAllocation.allocationTotalT), alignment: 'right' });
      dataRow.push({ text: this.formatMoney(this.programAllocation.allocationTotal), alignment: 'right' });
      body.push(dataRow);
      return body;
    },
    maketableAllocFTE(data) {
      return {
        style: 'tableHeader',
        table: {
          headerRows: 1,
          body: this.buildTableBodyAllocFTE(data),
        },
      };
    },
    buildTableBodyAllocFTE(data) {
      const body = [];
      body.push(['', { text: 'Appropriated', alignment: 'center', colSpan: 2 }, { text: 'Unappropriated' }, 'Unappropriated']);
      body.push(['Org ID', 'Perm', 'Temp', 'Temp']);
      data.forEach((row) => {
        const dataRow = [];
        if (row.orgId === 'Total Allocation') {
          dataRow.push(row.orgId);
        } else {
          dataRow.push(`${row.orgId} - ${row.orgName}`);
        }
        dataRow.push({ text: row.fteAppropriatedPerm.toFixed(2), alignment: 'right' });
        dataRow.push({ text: row.fteAppropriatedTemp.toFixed(2), alignment: 'right' });
        dataRow.push({ text: row.fteUnappropriatedTemp.toFixed(2), alignment: 'right' });
        body.push(dataRow);
      });
      return body;
    },
    formatMoney(number) {
      if (number === 0) {
        return '$0';
      }
      let formatNumber = number.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      formatNumber = formatNumber.replace('.00', '');
      return formatNumber;
    },
    checkFed() {
      if (this.programAllocation.isFedPayrollCert === true) {
        return 'Federal Payroll';
      }
      return '';
    },
    checkFedLink() {
      if (this.programAllocation.isFedPayrollCert === true) {
        return `${process.env.VUE_APP_DOCS_BASE_URL}/${this.programAllocation.fedPayrollPdfLink}`;
      }
      return '';
    },
    checkFringe() {
      if (this.programAllocation.isFringeBenefit === true) {
        return 'Fringe Benefit Link';
      }
      return '';
    },
    checkFringeLink() {
      if (this.programAllocation.isFringeBenefit === true) {
        return `${process.env.VUE_APP_DOCS_BASE_URL}/${this.programAllocation.fringeBenefitPdfLink}`;
      }
      return '';
    },
  },
  created() {
    this.allocationId = this.$route.params.allocationId;
    if (this.allocationId) {
      this.getAllocation();
    }
  },
};
</script>

<style scoped lang="scss">
  .allocation {
    .back-btn {
      float: right;
    }

    .print-btn {
      float: right;
      margin-left: 10px;
    }
    .allocation-total-section {
      padding-right: 25px;
    }

    .allocation-fte {
      width: 75%;
    }

    .rationale-text {
      font-size: 15px;
      color: #EB5757;
      margin-bottom: 10px;
    }
  }
</style>
